export const PRICING_PLANS = {
    'Companies': {
        "plans": ["FREE", "LITE", "PRO", "PRO Plus"],
        "pricing": {
            "FREE": "£0",
            "LITE": "£8.25",
            "PRO": "£83.25",
            "PRO Plus": "Custom"
        },
        "buttonText": {
            "FREE": <div className='df aic jcc fdc fw600'>Get Started <p className='fs10px fw400'>No credit card required</p></div>,
            "LITE": <div className='df aic jcc fdc fw600'>Get Started <p className='fs10px fw400'>Upgrade from dashboard</p></div>,
            "PRO": <div className='df aic jcc fdc fw600'>Get Started <p className='fs10px fw400'>Upgrade from dashboard</p></div>,
            "PRO Plus": "Book a call"
        },
        "features": {
            "Your Investment Journey &": {
                "Investment Readiness Checklist": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": 'image1'
                },
                "Completeness and Risk Scoring": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Bespoked reporting with recommendations for remediation ": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Foundational Diligence": {
                    "KPI Report": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Data Repository": {
                        "FREE": false,
                        "LITE": "20 sections",
                        "PRO": "160 sections & User defined sections & AI Filing Manager",
                        "PRO Plus": false
                    },
                    "Sync": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "RAG AI Foundation Layer": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Business Audit": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Draft Directors’ Questionnaires": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Draft Warranty Disclosures": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Workflow Manager": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Unaudited Certification": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                },
                "Value Diligence": {
                    "AnyList Checklist Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Diligentsia AppStore access": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "ResearchAid Reports": {
                    "Market Opportunity": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Route To Market": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Competitor Analysis": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Technology Advantage": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "SWOT": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "ResearchAid Report Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                },
                "InvestorMatch": {
                    "OneForm Investor Application": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Database InvestorMatch​": {
                        "FREE": "Count",
                        "LITE": "+ Names",
                        "PRO": "+ FIT Reports",
                        "PRO Plus": false
                    },
                    "InvestorMatch – 1-click introductions (gold certification only)​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
            },
            "Your Growth Journey & ": {
                "Growth Readiness Checklist": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Completeness and Risk Scoring": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Bespoked reporting with recommendations for remediation ": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Foundational Diligence": {
                    "KPI Report": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Data Repository": {
                        "FREE": false,
                        "LITE": "20 sections",
                        "PRO": "160 sections & User defined sections & AI Filing Manager",
                        "PRO Plus": false
                    },
                    "Sync": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "RAG AI Foundation Layer": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Business Audit": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    // "Draft Directors’ Questionnaires": {
                    //     "FREE": false,
                    //     "LITE": false,
                    //     "PRO": "AppStore (extra)",
                    //     "PRO Plus": false
                    // },
                    // "Draft Warranty Disclosures": {
                    //     "FREE": false,
                    //     "LITE": false,
                    //     "PRO": "AppStore (extra)",
                    //     "PRO Plus": false
                    // },
                    "Workflow Manager": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Unaudited Certification": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                },
                "Value Diligence": {
                    "AnyList Checklist Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Diligentsia AppStore access": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "ResearchAid Reports": {
                    "Market Opportunity": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Route To Market": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Competitor Analysis": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Technology Advantage": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "SWOT": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "ResearchAid Report Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                },
                "Healthboost Modules": {
                    "Cybersecurity Review - partner module": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Loan Readiness Checklist - partner module": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Enhancing Your Business Plan​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Long Term Growth Planning​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Improving Your KPIs": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Mitigating Your Key Risks​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Improving Compliance​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Building New Funding Relationships​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Improving Your Existing Funding Terms​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Increasing Your Revenues​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Driving Your Margins and Profit​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Improving Your Cashflow​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Boosting Outsourcing Efficiency​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Strengthen Your Internal Controls​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Optimising Your Taxation​​": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Enhancing Your Social Media": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },

                },
            },
            "Your Exit Journey & ": {
                "Investment Readiness Checklist": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Completeness and Risk Scoring": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Bespoked reporting with recommendations for remediation ": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Foundational Diligence": {
                    "KPI Report": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Data Repository": {
                        "FREE": false,
                        "LITE": "20 sections",
                        "PRO": "160 sections & User defined sections & AI Filing Manager",
                        "PRO Plus": false
                    },
                    "Sync": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "RAG AI Foundation Layer": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Business Audit": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Draft Directors’ Questionnaires": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Draft Warranty Disclosures": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Workflow Manager": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Unaudited Certification": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                },
                "Value Diligence": {
                    "AnyList Checklist Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Diligentsia AppStore access": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "ResearchAid Reports": {
                    "Market Opportunity": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Route To Market": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Competitor Analysis": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Technology Advantage": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "SWOT": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "ResearchAid Report Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                },
                "Exit Introductions​": {
                    "Corporate Finance Boutiques (larger companies)": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Businesses For Sale (smaller companies) ": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
            },
            "Support": {
                "Agentic and telephone support": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Account Manager": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                }
            },
            "Dedicated Advisor": {
                "Can't or don’t want to do it yourself?": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": false,
                    "PRO Plus": true
                },
                "Diligentsia Audited Certification": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": false,
                    "PRO Plus": true
                }
            },
        }
    },
    'Advisors': {
        "plans": ["Portfolio PRO", "Portfolio PRO ", "PRO Plus"],
        "subTitle": {
            "Portfolio PRO": "Dashboard and tools for you",
            "Portfolio PRO ": "For your client company",
            "PRO Plus": "For a Client Project"
        },
        "pricing": {
            "Portfolio PRO": "FREE",
            "Portfolio PRO ": "£66.67",
            "PRO Plus": "Custom"
        },
        "buttonText": {
            "Portfolio PRO": <div className='df aic jcc fdc fw600'>Get Started <p className='fs10px fw400'>No credit card required</p></div>,
            "Portfolio PRO ": '',
            "PRO Plus": "Book a call"
        },
        tag: {
            "Portfolio PRO": true
        },
        discount: {
            "Portfolio PRO ": '20%',
        },
        "features": {
            "Boost Margins - New Revenue Streams - New Clients": {
                "FREE Portfolio Pro Account": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image1',
                    "PRO Plus": 'image5'
                },
                "FREE Portfolio dashboard to monitor the progress of all your clients": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Put all your clients on the same data repository structure to aid document access - saves time for everyone": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "WorkFlow Manager": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Client Benchmarking": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Connect with Investor database once achieved gold unaudited certification": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Offer new service revenue streams to existing clients": {
                    "Assist with preparation Unaudited Certification": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    },
                    "Chargeable quarterly reviews": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    },
                    "Delivery of new AppStore services": {
                        "Portfolio PRO": false,
                        "Portfolio PRO ": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Focal point for integration of new RAG foundation layer and AI tools": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    },
                },
                "Find new clients": {
                    "Promotion to potential new clients": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    },
                    "Context sensitive service leads": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    }
                },
            },
            "Accelerate Your Client’s Investment Journey &": {
                "All Company Pro tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image2',
                    "PRO Plus": 'image6'
                },
                "Investment Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Foundational Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Value Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "InvestorMatch – 1-click introductions (gold certification only)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
            },
            "Accelerate Your Client’s Growth Journey &": {
                "All Company Pro tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image3',
                    "PRO Plus": 'image7'
                },
                "Growth Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "20 x Healthboost Modules to systematically improve each area of the business": {
                    "Portfolio PRO": "AppStore (extra)",
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AppStore modules for focussed improvement": {
                    "Portfolio PRO": "AppStore (extra)",
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Focal point for integration of new RAG foundation layer and AI tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
            },
            "Accelerate Your Client’s Exit Journey &": {
                "All Company Pro tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image4',
                    "PRO Plus": 'image8'
                },
                "Exit Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Foundational Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": "AppStore (extra)",
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Value Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Corporate Finance Boutiques (larger companies)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Businesses For Sale (smaller companies)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                }
            },
            "Support": {
                "Agentic and telephone support": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Account Manager": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                }
            },
            "Dedicated Advisor (fixed price packages or bespoke)": {
                "Clients can't or don’t want to do it yourself?": {
                    "Portfolio PRO": "-",
                    "Portfolio PRO ": false,
                    "PRO Plus": true
                },
                "Diligentsia Audited Certification": {
                    "Portfolio PRO": "-",
                    "Portfolio PRO ": false,
                    "PRO Plus": true
                }
            },
        }
    },
    'Investors': {
        "plans": ["Portfolio PRO", "Portfolio PRO "],
        "subTitle": {
            "Portfolio PRO": "Dashboard and tools for you",
            "Portfolio PRO ": "For your Applicant Company",
        },
        "pricing": {
            "Portfolio PRO": "FREE",
            "Portfolio PRO ": "£66.67",
        },
        "buttonText": {
            "Portfolio PRO": <div className='df aic jcc fdc fw600'>Get Started <p className='fs10px fw400'>No credit card required</p></div>,
            "Portfolio PRO ": '',
        },
        tag: {
            "Portfolio PRO": true
        },
        discount: {
            "Portfolio PRO ": '20%',
        },
        "features": {
            "FREE Triaging of Applicant Companies &": {
                "FREE Portfolio Pro Account": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image1',
                },
                "FREE Portfolio dashboard to monitor the progress of all your portfolio companies and applicants": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "OneForm InvestorMatch application (or integration of your existing form) - from your web site": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "Fit Report on each applicant against your criteria": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "Investment Readiness Report": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "WorkFlow Manager": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "ResearchAid Reports": {
                    "Market Opportunity": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                    },
                    "Route To Market": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                    },
                    "Competitor Analysis": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                    },
                    "Technology Advantage": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                    },
                    "SWOT": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                    }
                },
                "Further Pre-Investment Diligence &": {
                    "Data Repository": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": 'image2',
                    },
                    "Sync": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                    },
                    "Business Audit": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                    },
                    "Draft Directors’ Questionnaires": {
                        "Portfolio PRO": "AppStore (extra)",
                        "Portfolio PRO ": false,
                    },
                    "Draft Warranty Disclosures": {
                        "Portfolio PRO": "AppStore (extra)",
                        "Portfolio PRO ": false,
                    },
                    "Further diligence - AnyList Checklist Builder": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                    },
                    "Further diligence - ResearchAid Report Builder": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                    },
                    "We can match your rejected applicants with other investors": {
                        "Portfolio PRO": "AppStore (extra)",
                        "Portfolio PRO ": false,
                    },
                },
            },
            "Post-Investment  Growth - Portfolio Companies &": {
                "Growth Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": "image3",
                },
                "100-Day Portfolio Value Growth Plan": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "20 x Healthboost Modules to systematically improve each area of the business": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "Put all your clients on the same data repository structure to aid document access - saves time for everyone": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "AppStore modules for focussed improvement": {
                    "Portfolio PRO": "AppStore (extra)",
                    "Portfolio PRO ": false,
                },
                "Quarterly portfolio Reviews": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "Portfolio Benchmarking": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "Focal point for integration of new RAG foundation layer and AI tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                }
            },
            "Portfolio Companies Permanently Exit Ready &": {
                "Exit Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": "image4",
                },
                "Foundational Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "Value Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
            },
            "Support": {
                "Agentic and telephone support": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "Account Manager": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                }
            },
            "Dedicated Advisor": {
                "Can't or don’t want to do it yourself?": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                },
                "Diligentsia Audited Certification": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                }
            },
        }
    },
}

export const INNERPAGE_PRICING_PLAN = {
    'Companies': {
        "plans": ["FREE", "LITE", "PRO", "PRO Plus"],
        "headings": ["FREE", "LITE", "PRO", "PRO Plus"],
        "pricing": {
            "FREE": "£0",
            "LITE": "£8.25",
            "PRO": "£83.25",
            "PRO Plus": "Custom"
        },
        "buttonText": {
            "FREE": <div className='df aic jcc fdc fw600'>Get Started <p className='fs10px fw400'>No credit card required</p></div>,
            "LITE": 'Buy Now',
            "PRO": 'Buy Now',
            "PRO Plus": "Book a call"
        },
        "features": {
            "We Get You Organised": {
                "Try us out for FREE - no credit card required": {
                    "FREE": true,
                    "LITE": false,
                    "PRO": false,
                    "PRO Plus": 'image1'
                },
                "Investment Readiness": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Growth Readiness": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Exit Readiness": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "OneForm Application to multiple investors": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "InvestorMatch - Looking for investment?": {
                    "FREE": "Number of matches",
                    "LITE": "Investor names",
                    "PRO": "InvestorConnect",
                    "PRO Plus": false
                },
                "Foundational Diligence Pack &": {
                    "FREE": false,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Value Diligence Pack &": {
                    "FREE": false,
                    "LITE": "5 reports",
                    "PRO": "Report Builder",
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Diligentsia AppStore access": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Workflow Manager": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Healthboost Modules": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": "AppStore (extra)",
                    "PRO Plus": false
                },
                "Unaudited Certification": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                },
                "BUY_BUTTONS": {
                    "FREE": 'Get Started',
                    "LITE": 'Buy Now',
                    "PRO": 'Buy Now'
                }
            }
        }
    }
}

export const FREE_PLAN = {
    title: 'FREE', price: 'FREE', subTitle: 'Let’s get to know each other',
    points: [
        "FREE - no credit card required",
        'Entry level service',
        "Straightforward business value with practical recommendations",
        "See the power of our AI in action",
        '2-Minute Test to your company and its objectives',
        'Key Performance Indicator (“KPI”) Report tailored to your business and its industry',
    ],
    buttonText: <div className="df jcc fdc aic w100">
        <div style={{ lineHeight: '13px' }}>Register for FREE</div>
        <div className="fw400 c21" style={{ lineHeight: '13px', fontStyle: 'italic', fontSize: '10px' }}>No credit card required</div>
    </div>,
    buttonIdentifier: 'register'

}

export const LITE_PLAN = {
    title: 'Lite', price: '£5', perMonth: true, subTitle: 'For micro businesses',
    hasWarning: [6, 7, 8],
    points: [
        "Aimed at  businesses <5 employees wanting to organise themselves better",
        '2-Minute Test to your company and its objectives',
        "Key Performance Indicators (“KPI”)Report tailored to your business and its industry",
        'Data Repository - 20 sections eg. contracts',
        <div className="df aic">Syncs with
            <span className="pl0-5rem">
                <img src={require('../../images/landingpage/social1.png')} className='w20 ' />
                <img src={require('../../images/landingpage/social2.png')} className='w20 ' style={{ marginLeft: '5px' }} />
                <img src={require('../../images/landingpage/social3.png')} className='w20 ' style={{ marginLeft: '5px' }} />
            </span>
        </div>,
        'Customised Business Audit to your company and its objectives',
        'No certification',
        'No collaboration with Investors or Advisors',
        'No access to Diligentsia AppStore'
    ],
    buttonText: 'Buy Now',
    buttonIdentifier: 'payment'
}

export const PRO_PLAN = {
    title: 'Pro', price: '£50', perMonth: true, subTitle: 'For SMEs',
    points: [
        "Aimed at growth businesses >5 employees",
        '2-Minute Test',
        "Customised Key Performance Indicators (KPIs)",
        'Data Repository - 20 sections, 160 subsections, user-defined sections, AI Filing Assistant',
        <div className="df aic">Syncs with
            <span className="pl0-5rem">
                <img src={require('../../images/landingpage/social1.png')} className='w20 ' />
                <img src={require('../../images/landingpage/social2.png')} className='w20 ' style={{ marginLeft: '5px' }} />
                <img src={require('../../images/landingpage/social3.png')} className='w20 ' style={{ marginLeft: '5px' }} />
            </span>
        </div>,
        'Customised Business Audit',
        <div className="df aic w100"><span style={{ width: "60%" }}>Unaudited Certification</span>
            <span className="pl0-5rem" style={{ width: '40%' }}>
                <img src={require('../../images/landingpage/certification1.png')} style={{ width: '24%' }} />
                <img src={require('../../images/landingpage/certification2.png')} style={{ marginLeft: '5px', width: '24%' }} />
                <img src={require('../../images/landingpage/certification3.png')} style={{ marginLeft: '5px', width: '24%' }} />
            </span>
        </div>,
        <div><span className="fw600">Diligentsia AppStore</span></div>,
        <div>Audited certification available via<span className="fw600"> Diligentsia PLUS</span></div>,
        <div>Collaborate and share with advisors and investors via <span className="fw600">Diligentsia Portfolio Pro</span></div>
    ],
    buttonText: 'Buy Now**',
    hasPopular: true,
    buttonIdentifier: 'payment'
}

export const FOOTER_PRO_PLAN = {
    title: 'Pro', price: '£50', perMonth: true, subTitle: 'For SMEs',
    points: [
        "Aimed at growth businesses >5 employees",
        '2-Minute Test',
        "Customised Key Performance Indicators (KPIs)",
        'Data Repository - 20 sections, 160 subsections, user-defined sections, AI Filing Assistant',
        <div className="df aic">Syncs to
            <span className="pl0-5rem">
                <img src={require('../../images/landingpage/social1.png')} className='w20 ' />
                <img src={require('../../images/landingpage/social2.png')} className='w20 ' style={{ marginLeft: '5px' }} />
                <img src={require('../../images/landingpage/social3.png')} className='w20 ' style={{ marginLeft: '5px' }} />
            </span>
        </div>,
        'Customised Business Audit',
        <div className="df aic w100"><span style={{ width: "60%" }}>Unaudited Certification</span>
            <span className="pl0-5rem" style={{ width: '40%' }}>
                <img src={require('../../images/landingpage/certification1.png')} style={{ width: '24%' }} />
                <img src={require('../../images/landingpage/certification2.png')} style={{ marginLeft: '5px', width: '24%' }} />
                <img src={require('../../images/landingpage/certification3.png')} style={{ marginLeft: '5px', width: '24%' }} />
            </span>
        </div>,
        <div><span className="fw600">Diligentsia AppStore</span></div>,
        <div>Audited certification available via<span className="fw600"> Diligentsia PLUS</span></div>,
        <div>Collaborate and share with advisors and investors via <span className="fw600">Diligentsia Portfolio Pro</span></div>
    ],
    buttonText: 'Buy Now**',
    hasPopular: true,
    hasFooterText: true,
    buttonIdentifier: 'payment'
}

export const PRO_PLUS_PLAN = {
    contactSection: true,
    title: 'Pro PLUS', price: 'Contact Us', subTitle: 'AUDITED diligence certification',
    points: [
        "Advisor supported diligence? Don’t want to?",
        'Consultancy services',
        "Addition assurance from professional third-parties",
        'Have your own accountant or lawyer work through your diligence modules',
        'Inexpensive - designed to be quick and cost-effective.',
        <div className="df aic w100"><span style={{ width: "60%" }}>Audited certification</span>
            <span className="pl0-5rem" style={{ width: '40%' }}>
                <img src={require('../../images/landingpage/au-certification1.png')} style={{ width: '24%' }} />
                <img src={require('../../images/landingpage/au-certification2.png')} style={{ marginLeft: '5px', width: '24%' }} />
                <img src={require('../../images/landingpage/au-certification3.png')} style={{ marginLeft: '5px', width: '24%' }} />
            </span>
        </div>,
    ],
    buttonText: <>
        <svg width="30" height="30" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.9" d="M33.3804 4.33135H30.3365C30.3365 4.06704 30.2812 3.80565 30.1742 3.56399C30.0671 3.32233 29.9106 3.10577 29.7148 2.92823C29.519 2.75069 29.2882 2.61612 29.0373 2.53317C28.7863 2.45022 28.5207 2.42072 28.2577 2.44659C27.7806 2.50563 27.3422 2.73901 27.0268 3.10184C26.7115 3.46466 26.5414 3.93129 26.5493 4.41196V5.27811C26.5493 5.7122 26.6983 6.13314 26.9716 6.47044C27.2448 6.80774 27.6256 7.04092 28.0503 7.13093C28.1718 7.15386 28.2795 7.22337 28.3505 7.32465C28.4215 7.42592 28.45 7.55091 28.4301 7.67296C28.4102 7.795 28.3433 7.90441 28.2438 7.97784C28.1443 8.05127 28.0201 8.0829 27.8976 8.06597C27.2514 7.93885 26.6694 7.59143 26.2509 7.083C25.8323 6.57457 25.6032 5.93665 25.6026 5.27811V4.33135H20.329C20.3267 4.08071 20.2747 3.83301 20.1759 3.60262C20.0772 3.37224 19.9337 3.16374 19.7537 2.98923C19.5738 2.81471 19.361 2.67764 19.1277 2.58597C18.8944 2.49429 18.6453 2.44983 18.3947 2.45517C18.1441 2.46051 17.897 2.51553 17.6678 2.61705C17.4387 2.71858 17.2319 2.86458 17.0596 3.04659C16.8872 3.22861 16.7527 3.44302 16.6639 3.67741C16.575 3.91179 16.5336 4.16147 16.5419 4.41199L16.5419 5.27811C16.5418 5.7122 16.6909 6.13313 16.9641 6.47043C17.2374 6.80773 17.6182 7.04091 18.0428 7.13093C18.1643 7.15388 18.272 7.2234 18.343 7.32467C18.4139 7.42593 18.4425 7.55091 18.4225 7.67293C18.4026 7.79496 18.3358 7.90436 18.2363 7.97779C18.1368 8.05121 18.0126 8.08285 17.8901 8.06595C17.244 7.93882 16.662 7.5914 16.2434 7.08297C15.8249 6.57455 15.5957 5.93663 15.5951 5.27809V4.33135H12.5512C11.7984 4.33275 11.0767 4.63244 10.5444 5.1648C10.012 5.69716 9.71233 6.41879 9.71094 7.17165V9.80842H36.2207V7.17165C36.2193 6.41878 35.9196 5.69715 35.3872 5.1648C34.8549 4.63244 34.1332 4.33275 33.3804 4.33135ZM17.4887 4.33135C17.4924 4.08268 17.5937 3.84544 17.7709 3.67089C17.9481 3.49634 18.1868 3.3985 18.4355 3.3985C18.6842 3.39851 18.9229 3.49636 19.1 3.67091C19.2772 3.84547 19.3786 4.08272 19.3822 4.33139L17.4887 4.33135ZM27.4961 4.33135C27.4998 4.08268 27.6012 3.84544 27.7784 3.67089C27.9555 3.49634 28.1942 3.3985 28.4429 3.3985C28.6916 3.39851 28.9303 3.49636 29.1075 3.67091C29.2846 3.84547 29.386 4.08272 29.3897 4.33139L27.4961 4.33135Z" fill="#FEFEFE" />
            <path opacity="0.9" d="M9.74219 17.1934C9.87852 17.459 10.8695 19.0329 10.954 19.27C11.2572 19.9563 11.3021 20.729 11.0806 21.4458C10.8591 22.1626 10.386 22.7752 9.74849 23.1707C9.7935 23.9237 10.1243 24.6311 10.6733 25.1485C11.2223 25.6658 11.9481 25.954 12.7024 25.9543H33.2286C34.0134 25.9531 34.7657 25.6409 35.3206 25.086C35.8755 24.5311 36.1877 23.7788 36.1888 22.994V11.0078H9.74219V17.1934ZM30.4261 13.3495C30.6717 13.3528 30.9061 13.4527 31.0786 13.6275C31.251 13.8023 31.3477 14.0381 31.3477 14.2837C31.3477 14.5292 31.251 14.765 31.0785 14.9398C30.906 15.1146 30.6717 15.2145 30.4261 15.2178C30.1805 15.2145 29.9461 15.1146 29.7736 14.9398C29.6012 14.7649 29.5045 14.5292 29.5045 14.2836C29.5045 14.038 29.6012 13.8023 29.7737 13.6275C29.9462 13.4527 30.1805 13.3528 30.4261 13.3495ZM30.4261 17.5469C30.6716 17.5503 30.9059 17.6502 31.0783 17.8251C31.2506 17.9999 31.3473 18.2355 31.3473 18.481C31.3473 18.7266 31.2506 18.9622 31.0782 19.137C30.9058 19.3118 30.6716 19.4117 30.4261 19.4152C30.1806 19.4117 29.9463 19.3118 29.7739 19.137C29.6016 18.9622 29.5049 18.7265 29.5049 18.481C29.5049 18.2355 29.6016 17.9999 29.774 17.825C29.9464 17.6502 30.1806 17.5503 30.4261 17.5469ZM30.4261 21.7442C30.6717 21.7475 30.9061 21.8474 31.0786 22.0223C31.251 22.1971 31.3477 22.4328 31.3477 22.6784C31.3477 22.924 31.251 23.1597 31.0785 23.3345C30.906 23.5094 30.6717 23.6092 30.4261 23.6126C30.1805 23.6092 29.9461 23.5093 29.7736 23.3345C29.6012 23.1597 29.5045 22.924 29.5045 22.6784C29.5045 22.4328 29.6012 22.1971 29.7737 22.0222C29.9462 21.8474 30.1805 21.7475 30.4261 21.7442ZM22.9655 13.3495C23.2111 13.3528 23.4455 13.4527 23.618 13.6275C23.7905 13.8023 23.8872 14.0381 23.8872 14.2837C23.8872 14.5292 23.7904 14.765 23.618 14.9398C23.4455 15.1146 23.2111 15.2145 22.9655 15.2178C22.7199 15.2145 22.4855 15.1146 22.3131 14.9398C22.1406 14.7649 22.0439 14.5292 22.0439 14.2836C22.0439 14.038 22.1406 13.8023 22.3131 13.6275C22.4856 13.4527 22.72 13.3528 22.9655 13.3495ZM22.9655 17.5469C23.211 17.5503 23.4453 17.6502 23.6177 17.8251C23.7901 17.9999 23.8867 18.2355 23.8867 18.481C23.8867 18.7266 23.79 18.9622 23.6177 19.137C23.4453 19.3118 23.211 19.4117 22.9655 19.4152C22.72 19.4117 22.4857 19.3118 22.3134 19.137C22.141 18.9622 22.0443 18.7265 22.0443 18.481C22.0443 18.2355 22.141 17.9999 22.3134 17.825C22.4858 17.6502 22.7201 17.5503 22.9655 17.5469ZM22.9655 21.7442C23.2111 21.7475 23.4455 21.8474 23.618 22.0223C23.7905 22.1971 23.8872 22.4328 23.8872 22.6784C23.8872 22.924 23.7904 23.1597 23.618 23.3345C23.4455 23.5094 23.2111 23.6092 22.9655 23.6126C22.7199 23.6092 22.4855 23.5094 22.3131 23.3345C22.1406 23.1597 22.0439 22.924 22.0439 22.6784C22.0439 22.4328 22.1406 22.1971 22.3131 22.0222C22.4856 21.8474 22.72 21.7475 22.9655 21.7442ZM15.505 13.3495C15.7493 13.3547 15.9818 13.4554 16.1527 13.63C16.3237 13.8047 16.4194 14.0393 16.4194 14.2837C16.4194 14.528 16.3236 14.7626 16.1527 14.9373C15.9818 15.1119 15.7492 15.2126 15.5049 15.2178C15.2606 15.2126 15.0281 15.1119 14.8572 14.9373C14.6862 14.7626 14.5905 14.528 14.5905 14.2836C14.5905 14.0393 14.6862 13.8046 14.8572 13.63C15.0281 13.4554 15.2607 13.3547 15.505 13.3495ZM15.505 17.5469C15.7493 17.552 15.9819 17.6527 16.1529 17.8273C16.3239 18.002 16.4196 18.2366 16.4196 18.481C16.4196 18.7254 16.3239 18.9601 16.1529 19.1347C15.9819 19.3094 15.7493 19.41 15.5049 19.4152C15.2606 19.41 15.028 19.3093 14.857 19.1347C14.686 18.9601 14.5902 18.7254 14.5902 18.481C14.5902 18.2366 14.686 18.002 14.857 17.8273C15.028 17.6527 15.2606 17.552 15.505 17.5469ZM15.505 21.7442C15.7493 21.7494 15.9819 21.8501 16.1529 22.0247C16.3239 22.1993 16.4197 22.434 16.4196 22.6784C16.4196 22.9228 16.3239 23.1575 16.1529 23.3321C15.9819 23.5067 15.7493 23.6074 15.5049 23.6126C15.2606 23.6074 15.028 23.5067 14.857 23.3321C14.686 23.1575 14.5902 22.9228 14.5902 22.6784C14.5902 22.434 14.686 22.1993 14.857 22.0247C15.028 21.85 15.2606 21.7494 15.505 21.7442Z" fill="#FEFEFE" />
            <path d="M21.993 30.9786L19.7586 29.6342C19.5111 29.4866 19.2327 29.3987 18.9453 29.3775C18.6579 29.3563 18.3695 29.4024 18.1031 29.512C17.8366 29.6217 17.5993 29.7919 17.4101 30.0092C17.2209 30.2266 17.0849 30.485 17.013 30.7641C16.9356 30.9948 16.8076 31.2054 16.6383 31.3802C16.4689 31.5551 16.2626 31.6898 16.0344 31.7746C15.8062 31.8593 15.5619 31.8919 15.3195 31.8699C15.0771 31.848 14.8427 31.772 14.6334 31.6476C13.2117 30.7997 11.9014 29.7777 10.7327 28.6054C9.56324 27.4388 8.54149 26.133 7.69034 24.7173C7.56427 24.5008 7.48903 24.2585 7.47032 24.0087C7.4516 23.7589 7.4899 23.5081 7.58232 23.2753C7.67473 23.0424 7.81885 22.8336 8.00378 22.6646C8.18871 22.4957 8.40963 22.3709 8.64984 22.2998C8.89934 22.2223 9.12966 22.0929 9.32573 21.9202C9.52179 21.7475 9.67919 21.5353 9.78762 21.2976C9.89604 21.0599 9.95306 20.802 9.95494 20.5407C9.95681 20.2794 9.90351 20.0207 9.79851 19.7814C9.84927 19.8024 8.3863 17.4031 8.35944 17.345C8.10616 16.9272 7.69801 16.6264 7.22391 16.5081C6.74982 16.3899 6.24821 16.4639 5.8284 16.7139C4.45345 17.5364 3.44502 18.8536 3.00966 20.3955C2.57429 21.9374 2.74495 23.5875 3.48667 25.0076C5.89802 29.647 9.67986 33.431 14.3178 35.8451C15.738 36.5888 17.3888 36.7613 18.9321 36.3271C20.4753 35.8929 21.794 34.8849 22.6179 33.5097C22.8707 33.0912 22.9468 32.5894 22.8297 32.1147C22.7125 31.6401 22.4115 31.2314 21.993 30.9786Z" fill="#FEFEFE" />
        </svg>
        <span style={{ marginLeft: '7px' }}>Book a Call</span>
    </>,
    buttonIdentifier: 'book-call'
}

export const PORTFOLIO_PRO_PLAN = {
    title: 'Portfolio Pro', price: <span className="c4">FREE</span>, subTitle: 'For advisors and Investors',
    points: [
        "Collaboration ecosystem",
        'FREE accounts for advisors and investors',
        'FREE Portfolio dashboard to monitor client/investee company progress',
        'FREE tools eg. bespoked anylist checklist builder, client benchmarking, activity updates',
        'Advisors - FREE revenue generating services - context sensitive service leads, Diligentsia Pro PLus ',
        'Investors - FREE curated leads with diligence packs, matching your investment criteria',
        'Either you subscribe your companies and recharge, OR your companies subscribe via an invitation from you via your dashboard'
    ],
    buttonText: <div className="df jcc fdc aic w100">
        <div style={{ lineHeight: '13px' }}>Try for FREE</div>
        <div className="fw400 c21" style={{ lineHeight: '13px', fontStyle: 'italic', fontSize: '10px' }}>No credit card required</div>
    </div>,
    hasHightlightSection: true,
    buttonIdentifier: 'register',
}
